import { render, staticRenderFns } from "./VPage.vue?vue&type=template&id=7d65fda5&"
import script from "./VPage.vue?vue&type=script&lang=js&"
export * from "./VPage.vue?vue&type=script&lang=js&"
import style0 from "./VPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d65fda5')) {
      api.createRecord('7d65fda5', component.options)
    } else {
      api.reload('7d65fda5', component.options)
    }
    module.hot.accept("./VPage.vue?vue&type=template&id=7d65fda5&", function () {
      api.rerender('7d65fda5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VPage.vue"
export default component.exports